/** Classic vector glyphs from the full editor, without its host/runtime scripts. */
const paths: Record<string, string> = {
  block:
    '<path d="M5 3h14a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5zm0 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm8-2h5v4h-5V8z"/>',
  dashed: '<path d="M3 11h4v2H3v-2zm7 0h4v2h-4v-2zm7 0h4v2h-4v-2z"/>',
  radius:
    '<path d="M4 20V9a5 5 0 0 1 5-5h11v2H9a3 3 0 0 0-3 3v11H4zm5 0V11a2 2 0 0 1 2-2h9v2h-8a1 1 0 0 0-1 1v8H9z"/>',
  "distribute-y":
    '<path d="M3 3h18v2H3V3zm0 16h18v2H3v-2zM8 8h8v3H8V8zm0 5h8v3H8v-3z"/>',
  "distribute-x":
    '<path d="M3 3h2v18H3V3zm16 0h2v18h-2V3zM8 8h3v8H8V8zm5 0h3v8h-3V8z"/>',
  "object-align-bottom":
    '<path d="M3 18h18v2H3v-2zM6 5h4v11H6V5zm8 3h4v8h-4V8z"/>',
  "object-align-center-y":
    '<path d="M3 11h3V5h4v6h4V7h4v4h3v2h-3v4h-4v-4h-4v6H6v-6H3v-2z"/>',
  "object-align-top": '<path d="M3 4h18v2H3V4zm3 4h4v11H6V8zm8 0h4v8h-4V8z"/>',
  "object-align-right":
    '<path d="M18 3h2v18h-2V3zM5 6h11v4H5V6zm3 8h8v4H8v-4z"/>',
  "object-align-center-x":
    '<path d="M11 3h2v3h6v4h-6v4h4v4h-4v3h-2v-3H7v-4h4v-4H5V6h6V3z"/>',
  "object-align-left": '<path d="M4 3h2v18H4V3zm4 3h11v4H8V6zm0 8h8v4H8v-4z"/>',
  depth:
    '<path d="M4 4h2v16H4V4zm14 0h2v16h-2V4zM8 8h8v2H8V8zm2 6h4v2h-4v-2z"/>',
  sides:
    '<path d="m12 3 9 6.5-3.4 10.5H6.4L3 9.5 12 3zm0 2.5L5.4 10l2.5 8h8.2l2.5-8L12 5.5z"/>',
  "stroke-width": '<path d="M4 5h16v1H4V5zm0 4h16v2H4V9zm0 6h16v4H4v-4z"/>',
  color:
    '<path d="M12 3a9 9 0 1 0 0 18c1.7 0 2.7-.9 2.7-2.2 0-.7-.3-1.2-.6-1.7-.2-.4-.3-.7-.3-1 0-.8.6-1.4 1.5-1.4H17a4 4 0 0 0 4-4C21 6.3 17 3 12 3zM7.5 12A1.5 1.5 0 1 1 7.5 9a1.5 1.5 0 0 1 0 3zm3-4A1.5 1.5 0 1 1 10.5 5a1.5 1.5 0 0 1 0 3zm4 0A1.5 1.5 0 1 1 14.5 5a1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>',
  opacity:
    '<path d="M4 4h16v16H4V4zm2 2v4h4V6H6zm8 0v4h4V6h-4zm-4 4v4h4v-4h-4zm-4 4v4h4v-4H6zm8 0v4h4v-4h-4z"/>',
  select:
    '<path d="M4 2.8 19.5 12 12 13.7 8.2 21 4 2.8zm2.9 4.4 2.3 9.7 1.5-4.8 4.9-1.1-8.7-3.8z"/>',
  rectangle: '<path d="M4 5h16v14H4V5zm2 2v10h12V7H6z"/>',
  ellipse:
    '<path d="M12 4c5.5 0 10 3.6 10 8s-4.5 8-10 8S2 16.4 2 12s4.5-8 10-8zm0 2c-4.5 0-8 2.7-8 6s3.5 6 8 6 8-2.7 8-6-3.5-6-8-6z"/>',
  polygon: '<path d="M12 3 22 21H2L12 3zm0 4.1L5.4 19h13.2L12 7.1z"/>',
  image:
    '<path d="M3 4h18v16H3V4zm2 2v9l4-4 3 3 3-4 4 5.3V6H5zm0 12h14l-4-5.3-2.8 3.7L9 13.2 5 17.3V18z"/>',
};
const strokes: Record<string, string> = {
  star: "m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z",
  undo: "m8 4-5 5 5 5M4 9h9a7 7 0 0 1 7 7v3",
  redo: "m16 4 5 5-5 5m4-5h-9a7 7 0 0 0-7 7v3",
  size: "M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5M5 5l5 5m9 9-5-5",
  fill: "m12 3 8 8-9 9-8-8 9-9Zm-7 9h13M7 2l6 6m7 7s-2 3-2 4a2 2 0 0 0 4 0c0-1-2-4-2-4Z",
  align: "M4 3v18M8 5h12v5H8zm0 9h8v5H8z",
  folder: "M3 7V4h6l3 3h9v13H3V7Zm0 3h18",
  delete: "M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7",
  settings:
    "M12 3v3m0 12v3M3 12h3m12 0h3M5.6 5.6l2.1 2.1m8.6 8.6 2.1 2.1M5.6 18.4l2.1-2.1m8.6-8.6 2.1-2.1M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-4 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
  save: "M4 3h13l3 3v15H4V3Zm4 0v6h8V3M8 21v-8h8v8",
  chevron: "m14 6-6 6 6 6",
  copy: "M8 8h12v13H8zM16 8V3H3v13h5",
  smoothing: "M3 17C6 17 6 7 12 7s6 10 9 10",
  rename: "m4 16 12-12 4 4-12 12-5 1 1-5Zm10-10 4 4",
  forward: "m6 14 6-6 6 6",
  backward: "m6 10 6 6 6-6",
  front: "M5 4h14M6 17l6-6 6 6",
  back: "M5 20h14M6 7l6 6 6-6",
  drag: "M8 6h.1M8 12h.1M8 18h.1M16 6h.1M16 12h.1M16 18h.1",
  visible:
    "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Zm13 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  hidden:
    "m3 3 18 18M9 5.5C15 3 20 9 22 12l-3 4M6 7C4 9 3 10 2 12c4 6 10 9 16 5",
  locked: "M5 10h14v11H5zM8 10V7a4 4 0 0 1 8 0v3M12 14v3",
  unlocked: "M5 10h14v11H5zM8 10V7a4 4 0 0 1 7.7-1.5M12 14v3",
};
export function setNativeIcon(button: HTMLElement, name: string) {
  if (!paths[name] && !strokes[name]) return;
  if (button.dataset.nativeIcon === name && button.querySelector("svg")) return;
  button.querySelector("svg")?.remove();
  button.dataset.nativeIcon = name;
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("aria-hidden", "true");
  svg.innerHTML =
    paths[name] ??
    `<path d="${strokes[name]}" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>`;
  button.prepend(svg);
}
export function installNativeIcons(root: HTMLElement) {
  for (const button of root.querySelectorAll<HTMLElement>(
    "[data-native-icon]",
  )) {
    setNativeIcon(button, button.dataset.nativeIcon!);
  }
}
